const SyncErrorType = {
    FB_OFFLINE: 'FB_OFFLINE',
    API_OFFLINE: 'API_OFFLINE', // Unused
    FB_NOT_LOGGED_IN: 'FB_NOT_LOGGED_IN',
    NO_FB_USER: 'NO_FB_USER', // Legacy
    READ_FB_USER_FAILED: 'READ_FB_USER_FAILED',
    LOGIN_WDM_FAILED: 'LOGIN_WDM_FAILED',
    IMPORT_FRIENDS_FAILED: 'IMPORT_FRIENDS_FAILED',
    FETCH_FRIENDS_FAILED: 'FETCH_FRIENDS_FAILED',
    SAVE_FRIENDS_FAILED: 'SAVE_FRIENDS_FAILED',
    CALCULATE_FRIENDS_FAILED: 'CALCULATE_FRIENDS_FAILED',
    SEND_RESULTS_FAILED: 'SEND_RESULTS_FAILED',
    SAVE_RESULTS_FAILED: 'SAVE_RESULTS_FAILED',
    API_ERROR: 'API_ERROR', // Unused
    NO_EXTENSION: 'NO_EXTENSION',
    TIMEOUT: 'TIMEOUT',
};

module.exports = SyncErrorType;
